<script>
  export let title;
  export let subtitle = "";
  export let tipe = "1";
  export let href="";
</script>

{#if tipe == '1'}
  <div class="my-5 mb-2 mx-2">
    <h2 class="text-lg">{title}</h2>
    {#if subtitle}
      <p class="text-sm text-gray-700">{subtitle}</p>
    {/if}
  </div>
{:else}
  {#if tipe == '2'}
    <div class="my-5 mb-2">
      <h2 class="text-xl">{title}</h2>
      {#if subtitle}
        <p class="text-sm text-gray-700">{subtitle}</p>
      {/if}
    </div>
  {:else}
    <header
      class="flex flex-col lg:flex-row items-center my-5 mb-2 py-6 pb-2 lg:py-0 text-center lg:text-left mx-2">
      <a href="{href}"
        class="border-2 border-gray-200 rounded-lg hover:bg-gray-200 lg:text-xl md:text-md text-lg font-semibold lg:px-3 md:px-0 px-3">
        #{title}
      </a>
      {#if subtitle}
        <a href="{href}" class="ml-auto hidden lg:block text-sm text-green-700">
          {subtitle}
        </a>
      {/if}
    </header>
  {/if}
{/if}
